import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nProvider"] */ "/vercel/path0/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"preload\":true,\"display\":\"swap\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/CalSans-SemiBold.woff2\",\"variable\":\"--font-cal\",\"preload\":true,\"display\":\"block\",\"weight\":\"600\"}],\"variableName\":\"calFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-inlinesvg/dist/index.mjs");
